var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_16",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 15.6923V8.30775C7 7.81058 7.177 7.385 7.531 7.031C7.885 6.677 8.31058 6.5 8.80775 6.5H16.1923C16.6894 6.5 17.115 6.677 17.469 7.031C17.823 7.385 18 7.81058 18 8.30775V15.6923C18 16.1894 17.823 16.615 17.469 16.969C17.115 17.323 16.6894 17.5 16.1923 17.5H8.80775C8.31058 17.5 7.885 17.323 7.531 16.969C7.177 16.615 7 16.1894 7 15.6923Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStop);
export default __webpack_public_path__ + "static/media/ic-stop.0cb3e42d8d253c4f8b7aa4d46aaa2acb.svg";
export { ForwardRef as ReactComponent };